import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { cx } from '@trinity/chat-components';
import { Dashboard } from '@/components/icons/Dashboard';
import type { WorkspaceGlobalSearchBarResultDashboard } from '@/types';
import ClickContainer from './Results.ClickContainer';
import styles from './style/Results.Transcript.module.css';

export default function ResultsDashboard({ className, index, item, highlighted }: Props) {
  return (
    <ClickContainer index={index} item={item}>
      <div className={cx(styles.root, { [styles.highlighted]: highlighted }, className)}>
        <Dashboard className={styles.icon} />
        <div className={styles.details}>
          <div className={styles.name}>{item.name}</div>
          <div className={styles.type}>Dashboard</div>
        </div>
        {highlighted && (
          <div className={styles.return}>
            <KeyboardReturnIcon />
          </div>
        )}
      </div>
    </ClickContainer>
  );
}
export { ResultsDashboard };

type Props = {
  className?: string;
  index: number;
  item: WorkspaceGlobalSearchBarResultDashboard;
  highlighted?: boolean;
};